@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

.richText {
    :where(h1, h2, h3) {
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(h1, h2) {
        font: var(--font-h-64);
    }

    :where(h3) {
        font: var(--font-h-48);
    }

    :where(h4, h5, h6) {
        font: var(--font-h-40);
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(p, li) {
        margin-block: var(--spacer-16);
        font: var(--font-p-18);

        i {
            font-style: italic;
        }
    }

    :where(ul, ol) {
        margin-block: var(--spacer-16);
        padding-left: 1.5em;

        ::marker {
            width: 1em;
        }
    }

    p:global(.fineprint) {
        font: var(--font-eyebrow);
        color: rgb(from currentColor r g b / 60%);
    }

    li {
        padding-left: 0.3em;
    }

    a {
        color: inherit;
        text-underline-offset: 0.1875em;

        &:focus-visible {
            border-radius: 4px;
            outline: var(--outline);
            outline-offset: 1px;
        }
    }

    a:global(.buttonFilled) {
        @include filled-button;

        margin-top: var(--spacer-16);
    }

    a:global(.buttonBorderless) {
        @include borderless-button;
    }

    :global(.eyebrow) {
        + :is(h1, h2, h3, h4, h5, h6) {
            margin-top: var(--spacer-16);
        }
    }

    img {
        display: inline;
    }

    hr {
        border-top: 0;
        border-bottom-style: solid;
        border-color: var(--color-contrast);
    }
}

.largeHeadings {
    :where(h1) {
        font: var(--font-h-96);
    }

    :where(p) {
        font: var(--font-h-32);
    }
}

.none {
    visibility: visible;
}

.firstChild {
    > *:first-child {
        margin-top: 0;
    }
}

.lastChild {
    > *:last-child {
        margin-bottom: 0;
    }
}

.both {
    composes: firstChild;
    composes: lastChild;
}
